import type { RouteRecordRaw } from 'vue-router';

export const theoryRoute: RouteRecordRaw = {
  path: '/pronouns/theory',
  name: 'PronounsTheory',
  component: () => import('./pages/PronounsTheoryPage.vue'),
  meta: { layout: 'main' },
};

export const personalRoute: RouteRecordRaw = {
  path: '/pronouns/personal',
  name: 'PronounsPersonal',
  component: () => import('./pages/PronounsPersonalPage.vue'),
  meta: { layout: 'main' },
};

export const possessivesRoute: RouteRecordRaw = {
  path: '/pronouns/possessives',
  name: 'PronounsPossessives',
  component: () => import('./pages/PronounsPossessivesPage.vue'),
  meta: { layout: 'main' },
};

export const demonstrativesRoute: RouteRecordRaw = {
  path: '/pronouns/demonstratives',
  name: 'PronounsDemonstratives',
  component: () => import('./pages/PronounsDemonstrativesPage.vue'),
  meta: { layout: 'main' },
};

export const indefiniteRoute: RouteRecordRaw = {
  path: '/pronouns/indefinite',
  name: 'PronounsIndefinite',
  component: () => import('./pages/PronounsIndefinitePage.vue'),
  meta: { layout: 'main' },
};

export const negativeRoute: RouteRecordRaw = {
  path: '/pronouns/negative',
  name: 'PronounsNegative',
  component: () => import('./pages/PronounsNegativePage.vue'),
  meta: { layout: 'main' },
};

export const reflexiveRoute: RouteRecordRaw = {
  path: '/pronouns/reflexive',
  name: 'PronounsReflexive',
  component: () => import('./pages/PronounsReflexivePage.vue'),
  meta: { layout: 'main' },
};

export const relativeRoute: RouteRecordRaw = {
  path: '/pronouns/relative',
  name: 'PronounsRelative',
  component: () => import('./pages/PronounsRelativePage.vue'),
  meta: { layout: 'main' },
};

export const definingRoute: RouteRecordRaw = {
  path: '/pronouns/defining',
  name: 'PronounsDefining',
  component: () => import('./pages/PronounsDefiningPage.vue'),
  meta: { layout: 'main' },
};
